// extracted by mini-css-extract-plugin
module.exports = {"select":"FundSelector_select__8BN1B","client":"FundSelector_client__2mLiT","clientDropdown":"FundSelector_clientDropdown__3RfoK"};